import { render, staticRenderFns } from "./default.vue?vue&type=template&id=2e7a78a3&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/base/Loader.vue').default,DashboardDesktopSidebar: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/dashboard/DesktopSidebar.vue').default,DashboardMobileTopbar: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/dashboard/MobileTopbar.vue').default,DashboardGeneralTopbar: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/dashboard/GeneralTopbar.vue').default,ModalsMobileOverlay: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/modals/MobileOverlay.vue').default})
